"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCursorSegment = exports.selectPrevSegment = exports.selectNextSegment = exports.selectSegment = exports.selectAll = void 0;
var get_1 = require("../get/get");
var staticValues_1 = require("../staticValues");
var utils_1 = require("../utils/utils");
exports.selectAll = function (selector, startingElem) {
    if (startingElem === void 0) { startingElem = document; }
    var elements = startingElem.querySelectorAll(selector);
    return utils_1.toArray(elements);
};
exports.selectSegment = function ($input, segment) {
    if (segment === void 0) { segment = 'hrs12'; }
    if (!$input)
        return;
    $input.setSelectionRange(staticValues_1.ranges[segment].start, staticValues_1.ranges[segment].end);
};
exports.selectNextSegment = function ($input) {
    if (!$input)
        return;
    var _a = get_1.getRangeOf($input).nextSegment(), start = _a.start, end = _a.end;
    $input.setSelectionRange(start, end);
};
exports.selectPrevSegment = function ($input) {
    if (!$input)
        return;
    var _a = get_1.getRangeOf($input).prevSegment(), start = _a.start, end = _a.end;
    $input.setSelectionRange(start, end);
};
exports.selectCursorSegment = function ($input) {
    if (!$input)
        return;
    var _a = get_1.getRangeOf($input).cursorSegment(), start = _a.start, end = _a.end;
    $input.setSelectionRange(start, end);
};
